import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import styles from './SettingsGrid.module.scss';
import type { ISettingsNav } from './types';

export const SettingsMenu = observer(function SettingsMenu({
  menuItems,
  mainColumn,
  onItemClick,
  collapsed,
}: {
  menuItems: ISettingsNav[];
  mainColumn: string | undefined;
  onItemClick: (path: string, item?: ISettingsNav) => void;
  collapsed: boolean;
}) {
  const { t } = useTranslation();

  const isActive = (id: string) => mainColumn === id;

  return (
    <aside className={clsx(styles.settingsMenu, collapsed && styles.settingsMenu_collapsed)}>
      <ul className={styles.mainColumn}>
        {menuItems.map((item) => {
          const title = t(`settings:${item.type}`);

          return (
            <li key={item.id} className={styles.mainColumnItem}>
              <button
                type="button"
                onClick={() => onItemClick(`/settings?section=${item.type}`, item)}
                disabled={item.disabled}
                title={collapsed ? title : undefined}
                className={clsx(
                  styles.mainColumnButton,
                  collapsed && styles.mainColumnButton_collapsed,
                  isActive(item.id) && styles.mainColumnButton__active,
                )}
              >
                {item.Icon}
                <span className={clsx(styles.mainColumnText, collapsed && styles.mainColumnText_collapsed)}>
                  {title}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </aside>
  );
});
